import i18n from '../i18n';

export function formatPrice(amount) {
    if (amount == null) return '';

    const currencySuffix = i18n.language === 'ar' ? ' درهم' : ' dhs';

    return new Intl.NumberFormat('fr-MA', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(amount) + currencySuffix;
}